import { render } from "./GiftsAll.vue?vue&type=template&id=5cdb470d"
import script from "./GiftsAll.vue?vue&type=script&lang=js"
export * from "./GiftsAll.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__